import { render, staticRenderFns } from "./outorderList.vue?vue&type=template&id=49adcebe&scoped=true&"
import script from "./outorderList.vue?vue&type=script&lang=js&"
export * from "./outorderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49adcebe",
  null
  
)

export default component.exports